import axios from '../../axios';

export default {
  namespaced: true,
  state: {
    allRegionPlaceTypes: [],
    regionPlacesNearProperty: [],
    filterItems: [],
    selectedFilters: [],
    allPlaces: [],
    milesFromProperty: 50,
  },
  getters: {
    getAllPlaces: (state) => state.allPlaces,
    getAllRegionPlaceTypes: (state) => state.allRegionPlaceTypes,
    getPoiNearProperty: (state) => state.regionPlacesNearProperty,
    getFilterItems: (state) => state.filterItems,
    getSelectedFilters: (state) => state.selectedFilters,
    getMilesFromProperty: (state) => state.milesFromProperty,
  },
  mutations: {
    setAllPlaces(state, payload) {
      state.allPlaces = payload;
    },
    setAllRegionPlaceTypes(state, payload) {
      state.allRegionPlaceTypes = payload;
    },
    setPoiNearProperty(state, payload) {
      state.regionPlacesNearProperty = payload;
    },
    setFilterItems(state, payload) {
      state.filterItems = payload;
    },
    setSelectedFilters(state, payload) {
      state.selectedFilters = payload.filter((item) => item.selected);
    },
    createFilterItems(state, obj) {
      // this function finds occurrences where a lowercase letter is followed by an uppercase letter. It replaces those occurrences with the lowercase letter, a space, and the uppercase letter. For example, it converts "camelCase" to "camel Case".
      // state.filterItems = Object.keys(obj).map((key) => ({ id: Number(key), label: obj[key].replace(/([a-z])([A-Z])/g, '$1 $2'), selected: false, count: 0 }));
      // modified the above the function to convert underscores (_) instead of camel case (julia 15-05-23)
      state.filterItems = Object.keys(obj).map((key) => ({
        id: Number(key),
        label: obj[key].replace(/_/g, ' '), // Replace underscore with space
        selected: false,
        count: 0,
      }));
    },
    setMilesFromProperty(state, payload) {
      state.milesFromProperty = payload;
    },
  },
  actions: {
    fetchAllRegionPlaceTypes({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/core/regionplaces/regionplacetypes').then((res) => {
          commit('setAllRegionPlaceTypes', res.data);
          commit('createFilterItems', res.data);
          return resolve(res.data);
        }).catch((error) => reject(error));
      });
    },
    async fetchAllPoi({ state, commit }, payload) {
      // note: MilesToVilla set on the backend (based on villa Region - See Region.RegionPlacesMilesToVillaInclude)
      try {
        payload.typesOfPlaces = state.filterItems.map((item) => item.id);
        const res = await axios.post('/core/regionplaces/regionplacesnearproperty', payload);
        commit('setAllPlaces', res.data);
        return res.data;
      } catch (error) {
        console.error('ERROR FETCHING ALL POINTS OF INTEREST - error: ', error);
        throw error;
      }
    },
    async fetchPoi({ commit }, payload) {
      // note: MilesToVilla set on the backend (based on villa Region - See Region.RegionPlacesMilesToVillaInclude)
      try {
        const res = await axios.post('/core/regionplaces/regionplacesnearproperty', payload);
        commit('setPoiNearProperty', res.data);
        return res.data;
      } catch (error) {
        console.error('ERROR FETCHING POINTS OF INTEREST - error: ', error);
        throw error;
      }
    },
    fetchPoiNearProperty({ commit }, payload) {
      // note: MilesToVilla set on the backend (based on villa Region - See Region.RegionPlacesMilesToVillaInclude)
      return new Promise((resolve, reject) => {
        axios.post('/core/regionplaces/regionplacesnearproperty', payload).then((res) => {
          commit('setPoiNearProperty', res.data);
          return resolve(res.data);
        }).catch((error) => reject(error));
      });
    },

  },
};
